export default "__VITE_ASSET__CNk_O7bS__"